export default "/images/sponsor1.png?0d9bbfa08543403b07a0713984e65952";